export const defaultServers = {
  "us": [
    {
      "id": "p_gcp_lowa",
      "name": "America"
    },
    {
      "id": "p_gcp_fra",
      "name": "Europe"
    },
    {
      "id": "p_gcp_singapore",
      "name": "Asia"
    }
  ],
  "jp": [
    {
      "id": "p_gcp_lowa",
      "name": "アメリカ"
    },
    {
      "id": "p_gcp_fra",
      "name": "ヨーロッパ"
    },
    {
      "id": "p_gcp_singapore",
      "name": "アジア"
    }
  ],
  "kr": [
    {
      "id": "p_gcp_lowa",
      "name": "북미 서버"
    },
    {
      "id": "p_gcp_fra",
      "name": "유럽 서버"
    },
    {
      "id": "p_gcp_singapore",
      "name": "아시아 서버"
    }
  ],
  "cn": [
    {
      "id": "p_gcp_lowa",
      "name": "美服"
    },
    {
      "id": "p_gcp_fra",
      "name": "欧服"
    },
    {
      "id": "p_gcp_singapore",
      "name": "亚服"
    }
  ],
  "tw": [
    {
      "id": "p_gcp_lowa",
      "name": "美服"
    },
    {
      "id": "p_gcp_fra",
      "name": "歐服"
    },
    {
      "id": "p_gcp_singapore",
      "name": "亞服"
    }
  ],
};

export const defaultServersCN = {
  'cn': [
    // {
    //   "id": "t_first",
    //   "name": "先行服"
    // },
    {
      "id": "p_cn",
      "name": "正式服"
    }
  ]
};

export const defaultHeros = {
  "cn": [
    {
      "id": "4001",
      "name": "宾|爆破新星"
    },
    {
      "id": "7002",
      "name": "希雅|众神之化身"
    },
    {
      "id": "3001",
      "name": "艾瑞卡|疾风追猎"
    },
    {
      "id": "5001",
      "name": "吉玛|冰结之心",
    },
    {
      "id": "5002",
      "name": "吉玛|冰火融合",
    },
    {
      "id": "1001",
      "name": "雷恩|怒火",
    },
    {
      "id": "1002",
      "name": "雷恩|怒影",
    },
    {
      "id": "2001",
      "name": "卡里诺|荣光游侠",
    },
    {
      "id": "2002",
      "name": "卡里诺|致命掠影",
    },
    {
      "id": "8001",
      "name": "尤加|时空幻象",
    },
    {
      "id": "8002",
      "name": "尤加|时空流逝",
    },
    {
      "id": "9001",
      "name": "莫托|号令征召",
    },
    {
      "id": "9002",
      "name": "莫托|冲锋征召",
    },
    {
      "id": "7001",
      "name": "希雅|众神之伟智",
    }
  ],
  "us": [
    {
      "id": "4001",
      "name": "Bing|Blast Nova"
    },
    {
      "id": "7002",
      "name": "Thea|Incarnation of the Gods"
    },
    {
      "id": "3001",
      "name": "Erika|Wind Stalker"
    },
    {
      "id": "5001",
      "name": "Gemma|Frostbitten Heart",
    },
    {
      "id": "5002",
      "name": "Gemma|Ice-Fire Fusion",
    },
    {
      "id": "1001",
      "name": "Rehan|Anger",
    },
    {
      "id": "1002",
      "name": "Rehan|Seething Silhouette",
    },
    {
      "id": "2001",
      "name": "Carino|Ranger of Glory",
    },
    {
      "id": "2002",
      "name": "Carino|Lethal Flash",
    },
    {
      "id": "8001",
      "name": "Youga|Spacetime Illusion",
    },
    {
      "id": "8002",
      "name": "Youga|Spacetime Elapse",
    },
    {
      "id": "9001",
      "name": "Moto|Order Calling",
    },
    {
      "id": "9002",
      "name": "Moto|Charge Calling",
    },
    {
      "id": "7001",
      "name": "Thea|Wisdom of The Gods",
    }
  ],
  "tw": [
    {
      "id": "4001",
      "name": "賓|爆破新星"
    },
    {
      "id": "7002",
      "name": "希雅|眾神之化身"
    },
    {
      "id": "3001",
      "name": "艾瑞卡|疾風追獵"
    },
    {
      "id": "5001",
      "name": "吉瑪|冰結之心",
    },
    {
      "id": "5002",
      "name": "吉瑪|冰火融合",
    },
    {
      "id": "1001",
      "name": "雷恩|怒火",
    },
    {
      "id": "1002",
      "name": "雷恩|怒影",
    },
    {
      "id": "2001",
      "name": "卡里諾|榮光遊俠",
    },
    {
      "id": "2002",
      "name": "卡里諾|致命掠影",
    },
    {
      "id": "8001",
      "name": "尤加|時空幻象",
    },
    {
      "id": "8002",
      "name": "尤加|時空流逝",
    },
    {
      "id": "9001",
      "name": "莫托|號令徵召",
    },
    {
      "id": "9002",
      "name": "莫托|衝鋒徵召",
    },
    {
      "id": "7001",
      "name": "希雅|眾神之偉智",
    }
  ],
  "jp": [
    {
      "id": "4001",
      "name": "ピン|ブラストノバ"
    },
    {
      "id": "7002",
      "name": "シーア|神々の化身"
    },
    {
      "id": "3001",
      "name": "エリカ|ウインドチェイサー"
    },
    {
      "id": "5001",
      "name": " ジェマ|氷結の心",
    },
    {
      "id": "5002",
      "name": " ジェマ|氷火融合",
    },
    {
      "id": "1001",
      "name": "リーハン|怒りの炎",
    },
    {
      "id": "1002",
      "name": "リーハン|レイジングシャドウ",
    },
    {
      "id": "2001",
      "name": "カリーノ|グローリーレンジャー",
    },
    {
      "id": "2002",
      "name": "カリーノ|ネクロスナップ",
    },
    {
      "id": "8001",
      "name": "ユーガ|時空イリュージョン",
    },
    {
      "id": "8002",
      "name": "ユーガ|時空スリップ",
    },
    {
      "id": "9001",
      "name": "モート|召集命令",
    },
    {
      "id": "9002",
      "name": "モート|突撃命令",
    },
    {
      "id": "7001",
      "name": "シーア|神々の英知",
    }
  ],
  "kr": [
    {
      "id": "4001",
      "name": "빈|블래스트 노바"
    },
    {
      "id": "7002",
      "name": "티아|신들의 화신"
    },
    {
      "id": "3001",
      "name": "에리카|바람의 추격자"
    },
    {
      "id": "5001",
      "name": "젬마|프로즌 하트",
    },
    {
      "id": "5002",
      "name": "젬마|빙화융합",
    },
    {
      "id": "1001",
      "name": "리한|분노의 불꽃",
    },
    {
      "id": "1002",
      "name": "리한|분노의 그림자",
    },
    {
      "id": "2001",
      "name": "카리노|영광의 레인저",
    },
    {
      "id": "2002",
      "name": "카리노|치명적 찰나",
    },
    {
      "id": "8001",
      "name": "유가|시공간의 환상",
    },
    {
      "id": "8002",
      "name": "유가|시공 유실",
    },
    {
      "id": "9001",
      "name": "모토| 소집 명령",
    },
    {
      "id": "9002",
      "name": "모토| 소집 돌격",
    },
    {
      "id": "7001",
      "name": "티아|위대한 신들의 지혜",
    }
  ],
};

export const defaultTitle = {
  "us": "Ranking",
  "jp": "ランキング",
  "kr": "헌터 랭킹",
  "cn": "猎人排行榜",
  "tw": "英雄排行榜",
};

export const defaultColumns = {
  "us": ["Ranking", "Player ID", "Level", "Time Used"],
  "jp": ["ランキング", "プレイヤーID", "レベル", "プレイ時間"],
  "kr": ["랭킹", "유저 ID", "레벨", "플레이타임"],
  "cn": ["排名", "玩家ID", "等级", "游戏时长"],
  "tw": ["排名", "玩家ID", "等級", "遊戲時長"],
};